import {InjectionToken, Signal, WritableSignal} from '@angular/core';
import {ConfigurationResponse as MwConfigurationResponse} from '@middleware';

/**
 * Interface defining the set of core application signals.
 * This structure centralizes critical, application-wide reactive state.
 */
export interface AppSignals {
  /**
   * The root WritableSignal that holds the main application configuration
   * returned from the middleware's status/configuration endpoint.
   * This signal is set by the appInitializer.
   */
  appConfig: WritableSignal<MwConfigurationResponse>;

  /**
   * The computed Signal that holds the instance-specific display name.
   * Computed from UI_CONFIG.
   */
  instanceName: Signal<string>;

  /**
   * The computed Signal that holds the instance-specific SEO "robots" meta tag content.
   * Computed from appConfig.
   */
  seoBotsMeta: Signal<string>;

  /**
   * The computed Signal that holds the hostname
   * Computed from appConfig.
   */
  hostname: Signal<string>;

  /**
   * The computed Signal that holds the environment name
   * Computed from appConfig.
   */
  envName: Signal<string>;
}

/**
 * Injection token for the centralized AppSignals object containing all
 * core application-level signals.
 */
export const APP_SIGNALS = new InjectionToken<AppSignals>('APP_SIGNALS');
